import { useEffect, useState } from "preact/hooks";
import store from "../store";
import { Space } from "antd";
import { CaretRightOutlined, PauseOutlined, UndoOutlined } from "@ant-design/icons";
import "antd/lib/space/style/index.css";

export default function CreateQRDesignModal() {
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
  }, []);

  function getVideos() {
    return document.querySelectorAll('.pages video');
  }

  function play() {
    setIsPlaying(true);
    getVideos().forEach((video: any) => {
      video.play();
    });
  }

  function pause() {
    setIsPlaying(false);
    getVideos().forEach((video: any) => {
      video.pause();
    });
  }

  function restart() {
    setIsPlaying(false);
    getVideos().forEach((video: any) => {
      video.pause();
      video.currentTime = 0;
    });
  }

  return (
    <div className={'video-playback-controls'}>
      <Space directon="horizontal">
        <a className="icn rwd-icon hint--top" data-hint="Restart" onClick={restart}>
          <UndoOutlined style={{ transform: "rotate(90deg)" }} />
        </a>

        {!isPlaying
          ? <a className="icn rwd-icon hint--top" data-hint="Play" onClick={play}>
            <CaretRightOutlined />
          </a>

          : <a className="icn rwd-icon hint--top" data-hint="Pause" onClick={pause}>
            <PauseOutlined />
          </a>
        }

      </Space >
    </div >
  )
}
